const UNITS = [
  { max: 60, unit: 'second' },
  { max: 3600, unit: 'minute', divisor: 60 },
  { max: 86400, unit: 'hour', divisor: 3600 },
  { max: 604800, unit: 'day', divisor: 86400 },
  { max: 2592000, unit: 'week', divisor: 604800 },
  { max: 31536000, unit: 'month', divisor: 2592000 },
  { max: Infinity, unit: 'year', divisor: 31536000 },
];

export default function timeAgo(dateStr) {
  if (!dateStr) return '';
  try {
    const seconds = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000);
    if (seconds < 5) return 'just now';
    for (const u of UNITS) {
      if (seconds < u.max) {
        const n = u.divisor ? Math.floor(seconds / u.divisor) : seconds;
        return `${n}${u.unit[0]} ago`;
      }
    }
    return '';
  } catch {
    return '';
  }
}
